import { render } from "./SignUpComponent.vue?vue&type=template&id=249dea0e&scoped=true"
import script from "./SignUpComponent.vue?vue&type=script&lang=js"
export * from "./SignUpComponent.vue?vue&type=script&lang=js"

import "./SignUpComponent.vue?vue&type=style&index=0&id=249dea0e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-249dea0e"]])

export default __exports__